import { Box, Heading, Text } from '@chakra-ui/react';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { EventListStatus } from '@/enums/EventListStatus';

interface INoContentAvailableProps {
  activeStatus: EventListStatus;
  query: string;
}
export const NoContentAvailable: FC<INoContentAvailableProps> = ({ activeStatus, query }) => {
  const { t } = useTranslation();

  const messageContent = useMemo(() => {
    if (query) return t(`eventListPage.searchNoResultsHeading`, { query });
    if (activeStatus === EventListStatus.upcoming) return t('eventListPage.upcomingEmptyMessage');
    else if (activeStatus === EventListStatus.past) return t('eventListPage.pastEmptyMessage');
    return t('eventListPage.liveEmptyMessage');
  }, [activeStatus, query]);

  return (
    <Box>
      <Heading fontSize={{ base: '2xl', md: '3xl' }}>{messageContent}</Heading>
      {query && <Text mt={4}>{t(`eventListPage.searchNoResultsDescription`)}</Text>}
    </Box>
  );
};
